import * as React from 'react';
import MUIInputAdornment from '@mui/material/InputAdornment';
import { styled } from '@mui/material';
import { Icon, IconProps } from './icon';

const InputAdornment: React.FC<{
  position: 'start' | 'end';
  iconName: IconProps['iconName'];
  onClick?: () => void;
  size: string;
}> = ({ position, iconName, ...props }) => (
  <MUIInputAdornment {...props} position="start">
    <Icon iconName={iconName} {...props} />
  </MUIInputAdornment>
);

export const BrandedInputAdornment = styled(InputAdornment)(({ theme }) => ({
  color: theme.palette.greyscale.white,
}));

export const ClearInputAdornment: React.FC<{
  handleClear: () => void;
  display: boolean;
}> = ({ handleClear, display }) => (
  <BrandedInputAdornment
    onClick={handleClear}
    iconName="clear"
    size="18px"
    position="end"
    sx={{ cursor: 'pointer', visibility: display ? 'visible' : 'hidden' }}
  />
);

export const PasswordInputAdornment: React.FC<{
  hidden: boolean;
  toggleVisible: (visible: boolean) => void;
}> = ({ toggleVisible, hidden }) => (
  <BrandedInputAdornment
    onClick={() => toggleVisible(!hidden)}
    iconName={hidden ? 'eye' : 'visibility-off'}
    size="medium"
    position="end"
    sx={{ cursor: 'pointer' }}
  />
);

export default InputAdornment;
